import * as React from "react";
import { constants } from "../../../../../store/parkingContracts";

import TableSelectField from "../../../Base/Fields/TableSelectField";
import CompanyTable from "src/components/Tables/Companies/FullTable";
import TenantTable from "src/components/Tables/Tenants/FullTableNewVersion";
import TenantNestedChildren from "src/components/Forms/Tenant/NestedChildren";
import TableSelectFieldWithCreate from "src/components/Forms/Base/Fields/TableSelectFieldWithCreate";

export default ({ method }) => {
  const storeName = constants.STORE_NAME;

  return (
    <>
      <div className="grid grid-cols-2 gap-6 mb-6">
        <TableSelectFieldWithCreate
          storeName={storeName}
          fieldKey="tenant"
          method={method}
          placeholder="Välj hyresgäst..."
          title="Hyresgäst"
          description="Välj hyresgäst på avtalet. Denna hyresgäst är även mottagare av avier för avtalet om avisering är aktiverat."
          TableComponent={TenantTable}
          createDisplayKey="user.first_name"
        >
          {(parentPath) => (
            <TenantNestedChildren
              storeName={storeName}
              method={method}
              parentInstructionsPath={"tenant"}
              parentPath={parentPath}
            />
          )}
        </TableSelectFieldWithCreate>
      </div>
      <div className="grid grid-cols-2 gap-6 mb-6">
        <TableSelectField
          storeName={storeName}
          fieldKey="landlord"
          method={method}
          placeholder="Välj hyresvärd..."
          title="Hyresvärd"
          description="Bolaget som ska stå som hyresvärd för avtalet"
          TableComponent={CompanyTable}
        />
      </div>
    </>
  );
};
